export default {
  XS: 0,
  SM: 600,
  MD: 900,
  LG: 1200,
  XL: 1536
};
